import { Feature } from "@omni/types/api/product/bff/shared/feature.model";
import { isDefined } from "@omni/utils/helper.utils";
import { parseFloatSafe } from "@omni/utils/number.utils";
import { InferType } from "yup";

import {
    CalculatorCodes,
    CalculatorConfig,
    CalculatorSchema
} from "../calculator.types";

export const getFeatureValue = (feature: Feature | undefined) => {
    const featureValue = feature?.featureValues.find(
        (featureValue) => featureValue.valid
    );
    if (!featureValue) return;

    const formattedValue = featureValue.formattedValue;
    if (!formattedValue) return;

    const numericValue = parseFloatSafe(formattedValue.replace(",", "."));

    return numericValue;
};

const resolveValues = ({
    codes,
    features
}: {
    codes: CalculatorCodes;
    features: Record<string, Feature>;
}) => {
    const values: Record<string, number> = {};

    for (const code of codes) {
        const value = getFeatureValue(features[code]);
        if (!isDefined(value)) return;

        values[code] = value;
    }

    return values;
};

export const calculate = <TSchema extends CalculatorSchema>({
    config,
    input,
    features
}: {
    config: CalculatorConfig<TSchema>;
    input: InferType<TSchema>;
    features: Record<string, Feature>;
}) => {
    for (const variant of config.variants) {
        const values = resolveValues({
            codes: variant.codes,
            features: features
        });

        if (values) {
            return variant.calculate({
                input: input,
                values: values
            });
        }
    }

    return null;
};
